import PersonSharpIcon from '@mui/icons-material/PersonSharp';
import { Avatar, Theme, Typography } from '@mui/material';
import React from 'react';

interface AvatarIconProps {
  user?: { firstName: string; lastName: string };
}

const avatarSx = (theme: Theme) => ({
  boxSizing: 'border-box',
  height: theme.spacing(4.5),
  width: theme.spacing(4.5),
  bgcolor: 'primary.main',
  color: '#FFF',
});

const AvatarIcon = (props: AvatarIconProps) => {
  const { user } = props;

  return (
    <Avatar
      variant="rounded"
      title={user ? `${user.firstName} ${user.lastName}` : ''}
      sx={avatarSx}
    >
      {user ? (
        <Typography data-testid="avatar-text-content" variant="subtitle2">
          {`${user.firstName.substring(0, 1)}${user.lastName.substring(0, 1)}`}
        </Typography>
      ) : (
        <PersonSharpIcon data-testid="avatar-icon" />
      )}
    </Avatar>
  );
};

export default AvatarIcon;
